/* @flow */

import utils from './utils';
import { callApiEndpoint } from './index';
import type { Purchase } from 'types';

const find = async (): Promise<Purchase[]> => {
  const endpoint = 'orderhistoryitems/findOrderHistoryItemForWorklistItemByUser';
  const response = await callApiEndpoint(endpoint, {
    method: 'GET',
  });
  return response.map(utils.toPurchase);
};

export default {
  find,
};
